import { SubjectAnpr } from 'shell/models/act-category-list';
import { Parenthood } from 'subscription/view-models/common-interface-subscription';
import { transformGenerality } from './transform-generality';

export const transformParenthood = (subjectAnpr?: SubjectAnpr): Parenthood => {
  return {
    generality: transformGenerality(subjectAnpr || {}),
  };
};
